import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const customers = (state = initialState.customers, action) => {
  switch (action.type) {
    case types.LOAD_CUSTOMER_SUCCESS:
      return action.customers;

    case types.CREATE_CUSTOMER_SUCCESS:
      return [...state, { ...action.customer }];

    case types.UPDATE_CUSTOMER_SUCCESS:
      return [
        ...state.filter((cust) => cust._id !== action.customer._id),
        { ...action.customer }
      ];

    case types.DELETE_CUSTOMER_SUCCESS:
      return [...state.filter((cust) => cust._id !== action.customerId)];

    default:
      return state;
  }
};

export const customer = (state = initialState.customer, action) => {
  switch (action.type) {
    case types.GET_CUSTOMER_SUCCESS:
      return action.customer;
    case types.UPDATE_CUSTOMER_SUCCESS:
      return action.customer;
    default:
      return state;
  }
};

export const savingCustomer = (state = initialState.savingCustomer, action) => {
  switch (action.type) {
    case types.SAVING_CUSTOMER:
      return action.savingCustomer;

    default:
      return state;
  }
};

export const customerToDelete = (
  state = initialState.customerToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_CUSTOMER_ID:
      return action.customerToDelete;

    default:
      return state;
  }
};

export const customerLocationToDelete = (
  state = initialState.customerLocationToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_LOCATION_ID:
      return action.customerLocationToDelete;

    default:
      return state;
  }
};

export const customerContactToDelete = (
  state = initialState.customerContactToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_CONTACT_ID:
      return action.customerContactToDelete;

    default:
      return state;
  }
};
// if needed in future
// export const customerCollectionToDelete = (
//   state = initialState.customerCollectionToDelete,
//   action
// ) => {
//   switch (action.type) {
//     case types.REQUEST_COLLECTION_ID:
//       return action.customerCollectionToDelete;

//     default:
//       return state;
//   }
// };

export const customerNoteToDelete = (
  state = initialState.customerNoteToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_NOTE_ID:
      return action.customerNoteToDelete;

    default:
      return state;
  }
};

export const inProgressCustomerProjects = (
  state = initialState.inProgressCustomerProjects,
  action
) => {
  switch (action.type) {
    case types.LOAD_IN_PROGRESS_CUSTOMER_PROJECTS_SUCCESS:
      return action.data;
    case types.CLEAR_IN_PROGRESS_CUSTOMER_PROJECTS_SUCCESS:
      return initialState.inProgressCustomerProjects;
    default:
      return state;
  }
};
